module.exports = __webpack_public_path__ + "img/mind_template_item_3_3.c2b43ec3.png";